const clevertap = require('clevertap-web-sdk');

function pushEvent(topic, payload) {
    const clevertapId= clevertap.getCleverTapID(); 
    const { event = '', page = '', data = {}, product = '' } = payload,
    key = `${product}_${page}_${event}`,
    finalData = { ...data, urlPath: window.location.href };
    if(clevertapId) {
        clevertap.event.push(key, finalData);
        console.log("pushEvent key-----",key)
    }
}

function sendCtDataToLogs(logsData) {
    var _tgsApiDomain = "//" + window.location.hostname;
    var options = {
        method: 'POST',
        url: _tgsApiDomain + '/xms/v1/log-push/',
        content: logsData,
        headers: {
            'content-type': 'application/json',
            Authorization: getCookieValue('uuid')
        }
    };
    makeExtCall(options);
}

function getCookieValue(name) {
    return (name = new RegExp('(?:^|;\\s*)' + ('' + name).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '=([^;]*)').exec(document.cookie)) && name[1];
}

function makeExtCall(options, callback, extraParam = {}) {
    var postData = {};
    if (options.method === 'POST') {
        postData = setPostData(options.content)
    }
    var finalOptions = Object.assign({}, postData, {
        method: options.method,
        headers: options.headers || {}
    });
    fetch(options.url, finalOptions).then(data => data.json()).then((res = {}) => {
        if (typeof callback === 'function') {
            callback(res, extraParam)
        }
    }).catch(error => {
        console.error(error);
        if (typeof callback === 'function') {
            callback(error, extraParam)
        }
    })
};

function setPostData(content) {
    return {
        body: JSON.stringify(content)
    }
}


function pushProfile(topic, payload) {
    const { data = {}, page = '', event = '' } = payload;
    const { metaData = {} } = data;
    const { role, mobile = '', email = '', userId: Identity = '', name = '', balance = '', ds = {} } = metaData,
        { currentDueInfo = {} } = ds,
        { dueDate = '' } = currentDueInfo;
    // const phone = `+91${mobile}`; 
    const clevertapId= clevertap.getCleverTapID(); 
    const ctData = {
        "Site": {
            "Name": name,
            "Identity": Identity,
            "Email": email,
            "Balance": balance,
            "Role": role,
            "CreditDueDate": dueDate,
            "Sales_Person_Pic":''
        }
    }
    if(clevertapId) {
        clevertap.onUserLogin.push(ctData);
        const logsData = {
            "userid": Identity,
            "username": name,
            "generationtime": new Date(),
            "clevertapId": clevertapId,
            page,
            event,
            ctData
        }
        console.log("pushProfile",{logsData})
        sendCtDataToLogs(logsData)
    }
}


module.exports = { pushEvent, pushProfile };
